// extracted by mini-css-extract-plugin
module.exports = {"AchievementsGuestPage":"styles_AchievementsGuestPage__3DiH5","AchievementsGuestPage__registration":"styles_AchievementsGuestPage__registration__14NxY"};